// extracted by mini-css-extract-plugin
export default {"ConfirmDialog":"styles_ConfirmDialog__FBDc-","questionMessage":"styles_questionMessage__rPSP7"};